import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=b74a75fc&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=b74a75fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74a75fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b74a75fc')) {
      api.createRecord('b74a75fc', component.options)
    } else {
      api.reload('b74a75fc', component.options)
    }
    module.hot.accept("./WithdrawModal.vue?vue&type=template&id=b74a75fc&scoped=true", function () {
      api.rerender('b74a75fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/financials-agent/components/Modal/WithdrawModal.vue"
export default component.exports